<template>
  <div class="evaluate">
    <a><em :style="{width: star1}"></em></a>
    <a><em :style="{width: star2}"></em></a>
    <a><em :style="{width: star3}"></em></a>
    <a><em :style="{width: star4}"></em></a>
    <a><em :style="{width: star5}"></em></a>
  </div>
</template>

<script>
  export default {
    props: ['qualityCode'],
    data () {
      return {
        star1: '0%',
        star2: '0%',
        star3: '0%',
        star4: '0%',
        star5: '0%'
      }
    },
    created () {
      var _this = this
      var code = _this.qualityCode
      if(code<1) {
        _this.star1 = code*100+'%'
      } else {
        _this.star1 = '100%'
        if(code<2) {
          _this.star2 = (code-1)*100+'%'
        } else {
          _this.star2 = '100%'
          if(code<3) {
            _this.star3 = (code-2)*100+'%'
          } else {
            _this.star3 = '100%'
            if(code<4) {
              _this.star4 = (code-3)*100+'%'
            } else {
              _this.star4 = '100%'
              _this.star5 = (code-4)*100+'%'
            }
          }
        }
      }
    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// CommentStars.vue?9d9ee90e